export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M19.18 5 8.59 15.579 4.42 11.41 3 12.82l5.59 5.59 11.999-12z\" clip-rule=\"evenodd\"/>"
};